/* eslint-disable */
import { produce } from "immer";
import {
  TIME_TRAVEL_ASSUMPTIONS_FETCH_START,
  TIME_TRAVEL_ASSUMPTIONS_FETCH_SUCCESS,
  TIME_TRAVEL_ASSUMPTIONS_FETCH_FAILURE,
} from "../actions/types";

const timeTravelAssumptions = (
  state = {
    fetching: false,
    data: {},
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case TIME_TRAVEL_ASSUMPTIONS_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case TIME_TRAVEL_ASSUMPTIONS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case TIME_TRAVEL_ASSUMPTIONS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default timeTravelAssumptions;
